module.exports = __webpack_public_path__ + "static/screenshot3-ee41614f4158c74e5d6123c3a07e6305.jpg";